/**
 * Function to format a price string (e.g. 19.3, 19.3489) to a 2 decimal place string. If the string
 * cannot be passed, simply returns the existing string.
 */
export function fPriceString(input: string): string {
  const num = parseFloat(input);
  if (Number.isNaN(num)) {
    return input;
  }
  return num.toFixed(2);
}
